var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGenerator = function SvgGenerator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.833 20.417a1.25 1.25 0 0 0 0 2.5h5a1.25 1.25 0 0 0 0-2.5zM22.917 21.667c0-.69.56-1.25 1.25-1.25h1.25v-1.25a1.25 1.25 0 1 1 2.5 0v1.25h1.25a1.25 1.25 0 0 1 0 2.5h-1.25v1.25a1.25 1.25 0 0 1-2.5 0v-1.25h-1.25c-.69 0-1.25-.56-1.25-1.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.25 6.667a1.25 1.25 0 1 0-2.5 0V8.75h-.417a4.583 4.583 0 0 0-4.583 4.583V30a4.583 4.583 0 0 0 4.583 4.583h23.334A4.584 4.584 0 0 0 36.25 30V13.333a4.584 4.584 0 0 0-3.333-4.41V6.668a1.25 1.25 0 0 0-2.5 0V8.75H11.25zm20.417 4.583H8.333a2.083 2.083 0 0 0-2.083 2.083V30a2.083 2.083 0 0 0 2.083 2.083h23.334A2.083 2.083 0 0 0 33.75 30V13.333a2.083 2.083 0 0 0-2.06-2.083z",
    clipRule: "evenodd"
  })));
};
export default SvgGenerator;